/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import OperationTheatre from './operation-theatre';
import OperationTheatreDetail from './operation-theatre-detail';
import OperationTheatreUpdate from './operation-theatre-update';
import OperationTheatreDeleteDialog from './operation-theatre-delete-dialog';

const OperationTheatreRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<OperationTheatre />} />
    <Route path="new" element={<OperationTheatreUpdate />} />
    <Route path=":id">
      <Route index element={<OperationTheatreDetail />} />
      <Route path="edit" element={<OperationTheatreUpdate />} />
      <Route path="delete" element={<OperationTheatreDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OperationTheatreRoutes;
